import SenderHeaderContent from '../headers/SenderHeaderContent';
// @ts-expect-error Untyped Dependency
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TypingHeaderContent extends PureComponent {
  render() {
    const {
      isSenderLoading,
      sender
    } = this.props;
    return /*#__PURE__*/_jsx(SenderHeaderContent, {
      sender: sender,
      isSenderLoading: isSenderLoading
    });
  }
}
TypingHeaderContent.displayName = 'TypingHeaderContent';
TypingHeaderContent.propTypes = {
  isSenderLoading: PropTypes.bool,
  sender: RecordPropType('Sender')
};